import { DISCORD_INVITE_URL } from '../links';
import { DiscordIcon } from './ui';

/** Opens the Discord invite in a new tab; renders nothing while no invite is set. */
export function DiscordLink() {
  if (!DISCORD_INVITE_URL) return null;
  return (
    <a
      className="hud-cut-sm inline-flex min-h-11 w-full items-center justify-center gap-2 bg-discord px-4 font-display text-sm font-bold uppercase tracking-[0.12em] text-white hover:bg-discord-strong motion-safe:transition-colors"
      href={DISCORD_INVITE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <DiscordIcon />
      Join our Discord
    </a>
  );
}
